<script setup lang="ts">
import type { Step } from '@/typings/forms/Step';

import StepNavigation from './StepNavigation.vue';

const currentStep = defineModel<number>({ required: true });

const steps: Step[] = [
  { 
    label: 'regionChoice'
  },
  { 
    label: 'projectChoice',
  },
  { 
    label: 'buildingChoice'
  },
  { 
    label: 'unitSelection'
  },
  {
    label: 'unitDetails'
  }
];
</script>

<template>
  <StepNavigation v-model="currentStep"
                  :steps="steps"
                  class="stepNavigation_unitSelectionSteps" />
</template>
